export function findClosestDate(data: any, accessor: any, target = Date.now()) {
    return data.reduce((prev: any, curr: any) => {
        const a = Math.abs(accessor(curr).toMillis() - target);
        const b = Math.abs(accessor(prev).toMillis() - target);
        return a - b < 0 ? curr : prev;
    })
}